import React from 'react';

const UserDefinedSecurityTabs = () => {
    return (
        <div>
            <h3>Security User Defined Fields</h3>
            <p>This is the security tab content.</p>
        </div>
    );
};

export default UserDefinedSecurityTabs; 